import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { BillingColumns } from '../../BillingColumns'
import { DescriptionMode } from '../../DescriptionMode'
import DetailsContainer from '../../DetailsContainer'
import { DetailsBillingSectionClientPricingItemFragment } from '../../../../../../../lib/graphql'
import LinePrices from '../../../pricing-item-details/LinePrices'
import { SingleLinePriceClientPricingItem } from '../../../pricing-item-details/single-line-price/SingleLinePrice'

interface IDetailsHouseProps {
  title?: {
    label: string
    icon?: React.ReactElement
  }
  columns: BillingColumns[]
  className?: string
  classNameItem?: string
  descriptionMode?: DescriptionMode
  showAdjustments?: boolean
  clientPricingItems: DetailsBillingSectionClientPricingItemFragment[]
  isFullBlue?: boolean
  hidePrice?: boolean
  emptyDate?: boolean
  onClickLinePrice?: (
    clientPricingItem: SingleLinePriceClientPricingItem,
  ) => void
  isModal?: boolean
  displayHeader?: boolean
}

const DetailsBillingSection = ({
  title,
  columns,
  className,
  classNameItem,
  descriptionMode = DescriptionMode.hidden,
  showAdjustments = false,
  isFullBlue = false,
  hidePrice = false,
  emptyDate = false,
  clientPricingItems,
  onClickLinePrice,
  isModal = false,
  displayHeader = true,
}: IDetailsHouseProps) => {
  if (clientPricingItems.length === 0) {
    return null
  }

  return (
    <div className={clsx(s.container, className)}>
      <DetailsContainer
        title={
          title && (
            <>
              {title.icon}
              {title.label}
            </>
          )
        }
        columns={columns}
        descriptionMode={descriptionMode}
        showAdjustments={showAdjustments}
        footer={false}
        emptyDate={emptyDate}
        isModal={isModal}
        displayHeader={displayHeader}
      >
        <div className={s.blockContainer}>
          {clientPricingItems.map((clientPricingItem) => {
            return (
              <LinePrices
                key={`${clientPricingItem._id}${
                  clientPricingItem.adjustmentStatus
                    ? `_${clientPricingItem.adjustmentStatus}`
                    : ''
                }`}
                className={clsx(classNameItem, isFullBlue ? s.fullBlue : '')}
                columns={columns}
                displayMode={descriptionMode}
                showAdjustments={showAdjustments}
                hidePrice={hidePrice}
                emptyDate={emptyDate}
                clientPricingItem={clientPricingItem}
                onClick={onClickLinePrice}
                displayPrice={!isModal}
              />
            )
          })}
        </div>
      </DetailsContainer>
    </div>
  )
}

export default DetailsBillingSection
